import './style.scss';
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import gsap from 'gsap';
import { Draggable } from "gsap/Draggable";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import imagesloaded from 'imagesloaded';

jQueryBridget( 'imagesloaded', imagesloaded, $ );

gsap.registerPlugin(Draggable);
gsap.registerPlugin(ScrollTrigger);

function heroSliderFunction() {
	if($(".wp-block-thefuturblocks-double-slider").length > 0) {
	    $(".wp-block-thefuturblocks-double-slider").each(function() {
	    	const self = $(this),
			slides = self.find(".wp-block-thefuturblocks-double-slide"),
			imageWrappers = slides.find(".wp-block-thefuturblocks-double-slide__image"),
			images = slides.find(".wp-block-thefuturblocks-double-slide__image img"),

			sImageWrappers = slides.find(".wp-block-thefuturblocks-double-slide__inner-image"),
			sImages = slides.find(".wp-block-thefuturblocks-double-slide__inner-image img"),

			innerHolds = slides.find(".wp-block-thefuturblocks-double-slide__inner-holder"),
			inners = slides.find(".wp-block-thefuturblocks-double-slide__inner"),
			
    		dots = self.find(".wp-block-thefuturblocks-double-slider__bullets"),
	        activeDotColor = dots.attr("data-active"),
	        dotColor = dots.attr("data-dot"),
	        dotBorderColor = dots.attr("data-bor-color"),
	        dotActiveBorderColor = dots.attr("data-bor-acolor"),
			nextNav = self.find(".wp-block-thefuturblocks-double-slider__nav-next"),
			prevNav = self.find(".wp-block-thefuturblocks-double-slider__nav-prev"),
			separator = self.find(".wp-block-thefuturblocks-double-slider__progress-separator"),
			navLine = self.find(".wp-block-thefuturblocks-double-slider__progress-line"),
			navIndex = self.find(".wp-block-thefuturblocks-double-slider__progress-index"),
			navLength = self.find(".wp-block-thefuturblocks-double-slider__progress-length");

			let moveSlideTL = gsap.timeline({paused:true}),
			nextLoop;

			function dotClick() {
		        if(!moveSlideTL.isActive()) {
		          let slideFrom = self.find(".wp-block-thefuturblocks-double-slide.active"),
					imgWrapperFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__image"),
					imgFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__image img"),
					sImgWrapperFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner-image"),
					sImgFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner-image img"),
					innerHoldFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner-holder"),
					innerFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner"),
		              sectionToIndex = $(this).index(),

		              slideTo = slides.eq(sectionToIndex),
		              imgWrapperTo = imageWrappers.eq(sectionToIndex),
						imgTo = images.eq(sectionToIndex),
						sImgWrapperTo = sImageWrappers.eq(sectionToIndex),
						sImgTo = sImages.eq(sectionToIndex),
						innerHoldTo = innerHolds.eq(sectionToIndex),
						innerTo = inners.eq(sectionToIndex);

					if(slideFrom.index() !== slideTo.index()) {
						if(slideFrom.index() < slideTo.index()) {
				            moveToSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, sImgTo, sImgFrom, sImgWrapperTo, sImgWrapperFrom, innerTo, innerFrom, innerHoldFrom, innerHoldTo);
				        } else {
				            moveFromSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, sImgTo, sImgFrom, sImgWrapperTo, sImgWrapperFrom, innerTo, innerFrom, innerHoldFrom, innerHoldTo);
				        }

						if (self.hasClass("has-autoplay")) {
						// Stop the last one
						  nextLoop.kill();
						  // Start it again
						  looper();
						}
					}
		          
		        }
		    }

			function nextClick() {
				if(!moveSlideTL.isActive()) {
					var slideFrom = self.find(".wp-block-thefuturblocks-double-slide.active"),
					imgWrapperFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__image"),
					imgFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__image img"),
					sImgWrapperFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner-image"),
					sImgFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner-image img"),
					innerHoldFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner-holder"),
					innerFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner"),
					sectionToIndex = slides.index(slideFrom);

					if(sectionToIndex !== slides.length - 1) {
						var slideTo = slides.eq(sectionToIndex + 1),
						imgWrapperTo = imageWrappers.eq(sectionToIndex + 1),
						imgTo = images.eq(sectionToIndex + 1),
						sImgWrapperTo = sImageWrappers.eq(sectionToIndex + 1),
						sImgTo = sImages.eq(sectionToIndex + 1),
						innerHoldTo = innerHolds.eq(sectionToIndex + 1),
						innerTo = inners.eq(sectionToIndex + 1);
						moveToSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, sImgTo, sImgFrom, sImgWrapperTo, sImgWrapperFrom, innerTo, innerFrom, innerHoldFrom, innerHoldTo);
					} else {
						slideTo = slides.eq(0);
						imgWrapperTo = imageWrappers.eq(0);
						imgTo = images.eq(0);
						sImgWrapperTo = sImageWrappers.eq(0);
						sImgTo = sImages.eq(0);
						innerHoldTo = innerHolds.eq(0);
						innerTo = inners.eq(0);
						moveToSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, sImgTo, sImgFrom, sImgWrapperTo, sImgWrapperFrom, innerTo, innerFrom, innerHoldFrom, innerHoldTo);
					}
					if (self.hasClass("has-autoplay")) {
					// Stop the last one
					  nextLoop.kill();
					  // Start it again
					  looper();
					}
				}
			}

			function prevClick() {
				if(!moveSlideTL.isActive()) {
					var slideFrom = self.find(".wp-block-thefuturblocks-double-slide.active"),
					imgWrapperFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__image"),
					imgFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__image img"),
					sImgWrapperFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner-image"),
					sImgFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner-image img"),
					innerHoldFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner-holder"),
					innerFrom = slideFrom.find(".wp-block-thefuturblocks-double-slide__inner"),
					sectionToIndex = slides.index(slideFrom);

					if(sectionToIndex !== 0) {
						var slideTo = slides.eq(sectionToIndex - 1),
						imgWrapperTo = imageWrappers.eq(sectionToIndex - 1),
						imgTo = images.eq(sectionToIndex - 1),
						sImgWrapperTo = sImageWrappers.eq(sectionToIndex - 1),
						sImgTo = sImages.eq(sectionToIndex - 1),
						innerHoldTo = innerHolds.eq(sectionToIndex - 1),
						innerTo = inners.eq(sectionToIndex - 1);
						moveFromSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, sImgTo, sImgFrom, sImgWrapperTo, sImgWrapperFrom, innerTo, innerFrom, innerHoldFrom, innerHoldTo);
					} else {
						slideTo = slides.eq(slides.length - 1);
						imgWrapperTo = imageWrappers.eq(slides.length - 1);
						imgTo = images.eq(slides.length - 1);
						sImgWrapperTo = sImageWrappers.eq(slides.length - 1);
						sImgTo = sImages.eq(slides.length - 1);
						innerHoldTo = innerHolds.eq(slides.length - 1);
						innerTo = inners.eq(slides.length - 1);
						moveFromSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, sImgTo, sImgFrom, sImgWrapperTo, sImgWrapperFrom, innerTo, innerFrom, innerHoldFrom, innerHoldTo);
					}
					if (self.hasClass("has-autoplay")) {
					// Stop the last one
					  nextLoop.kill();
					  // Start it again
					  looper();
					}
				}
			}

			function moveToSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, sImgTo, sImgFrom, sImgWrapperTo, sImgWrapperFrom, innerTo, innerFrom, innerHoldFrom, innerHoldTo) {
					moveSlideTL = gsap.timeline({onStart: setActiveSlide, onStartParams: [slideTo], onUpdate: updateIndex});
						moveSlideTL
						.to(innerFrom, {duration: 0.6, xPercent:100,ease:"power4.out"})
						.to(innerHoldFrom, {duration: 0.6, xPercent:-100,ease:"power4.out"},"<")

						.to(imgWrapperFrom, {duration:1.3,xPercent:-100,ease:"sine.out"},"<")
						.to(imgFrom, {duration:1.3,xPercent:100,ease:"sine.out"}, "<")
						.fromTo(imgWrapperTo, {xPercent:100}, {duration:1.3,xPercent:0,ease:"sine.out"}, "<")
						.fromTo(imgTo, {xPercent:-100}, {duration:1.3,xPercent:0,ease:"sine.out"}, "<")

						.to(sImgWrapperFrom, {duration:1.3,xPercent:100,ease:"sine.out"},"<")
						.to(sImgFrom, {duration:1.3,xPercent:-115, scale:1.3,ease:"sine.out"}, "<")
						.fromTo(sImgWrapperTo, {xPercent:-100}, {duration:1.3,xPercent:0,ease:"sine.out"}, "<")
						.fromTo(sImgTo, {xPercent:115, scale:1.3}, {duration:1.3,xPercent:0, scale:1,ease:"sine.out"}, "<")

						.set(slideTo, {autoAlpha:1, className: "wp-block-thefuturblocks-double-slide active"}, "<")
						.set(slideFrom, {className: "wp-block-thefuturblocks-double-slide"}, "<")

						.fromTo(innerHoldTo, {xPercent:100},
	             		{duration: 0.6, xPercent:0,ease:"sine.out"},"<0.7")
						.fromTo(innerTo, {xPercent:-100},
	             		{duration: 0.6, xPercent:0,ease:"sine.out"},"<")
						.set(slideFrom, {clearProps:"all"});
			}

			function moveFromSlide(slideFrom, slideTo, imgWrapperFrom, imgWrapperTo, imgFrom, imgTo, sImgTo, sImgFrom, sImgWrapperTo, sImgWrapperFrom, innerTo, innerFrom, innerHoldFrom, innerHoldTo) {
					moveSlideTL = gsap.timeline({onStart: setActiveSlide, onStartParams: [slideTo], onUpdate: updateIndex});
						moveSlideTL
						.to(innerFrom, {duration: 0.6, xPercent:-100,ease:"sine.out"})
						.to(innerHoldFrom, {duration: 0.6, xPercent:100,ease:"sine.out"},"<")

						.to(imgWrapperFrom, {duration:1.3,xPercent:100,ease:"sine.out"},"")
						.to(imgFrom, {duration:1.3,xPercent:-100,ease:"sine.out"}, "<")
						.fromTo(imgWrapperTo, {xPercent:-100}, {duration:1.3,xPercent:0,ease:"sine.out"}, "<")
						.fromTo(imgTo, {xPercent:100}, {duration:1.3,xPercent:0,ease:"sine.out"}, "<")

						.to(sImgWrapperFrom, {duration:1.3,xPercent:-100,ease:"sine.out"},"<")
						.to(sImgFrom, {duration:1.3,xPercent:115, scale:1.3,ease:"sine.out"}, "<")
						.fromTo(sImgWrapperTo, {xPercent:100}, {duration:1.3,xPercent:0,ease:"sine.out"}, "<")
						.fromTo(sImgTo, {xPercent:-115, scale:1.3}, {duration:1.3,xPercent:0, scale:1,ease:"sine.out"}, "<")

						.set(slideTo, {autoAlpha:1, className: "wp-block-thefuturblocks-double-slide active"}, "<")
						.set(slideFrom, {className: "wp-block-thefuturblocks-double-slide"}, "<")

						.fromTo(innerHoldTo, {xPercent:-100},
	             		{duration: 0.6, xPercent:0,ease:"sine.out"},"<0.7")
						.fromTo(innerTo, {xPercent:100},
	             		{duration: 0.6, xPercent:0,ease:"sine.out"},"<")
						.set(slideFrom, {clearProps:"all"});
					
			}

			function setActiveSlide(slideTo) {
		        var currentSlideIndex = slides.index(slideTo),
		          activeDot = self.find(".wp-block-thefuturblocks-double-slider__bullet.active"),
		          activeDotInner = activeDot.find(".wp-block-thefuturblocks-double-slider__bullet-inner"),
		          defDot = self.find(".wp-block-thefuturblocks-double-slider__bullet").eq(currentSlideIndex),
		          defDotInner = defDot.find(".wp-block-thefuturblocks-double-slider__bullet-inner");
		        gsap.to(activeDot, {duration:0.6,className: "wp-block-thefuturblocks-double-slider__bullet"});
		        gsap.to(activeDotInner, {duration:0.6,backgroundColor:dotColor, borderColor:dotBorderColor});
		        gsap.to(defDot, {duration:0.6,className: "wp-block-thefuturblocks-double-slider__bullet active"});
		        gsap.to(defDotInner, {duration:0.6,backgroundColor:activeDotColor, borderColor:dotActiveBorderColor});

		    }

			function updateIndex() {
				var active = slides.index($(".wp-block-thefuturblocks-double-slide.active")) + 1;
				if(active.toString().length < 2) active = '0' + active;
				navIndex.text(active);

				var lineWidth = 100/slides.length * active;
				gsap.to(navLine, {width:`${lineWidth}%`, duration:0.5});
			}

			function slideIndex() {
				var active = slides.index($(".wp-block-thefuturblocks-double-slide.active")) + 1,
					slideLength = slides.length;
				if(active.toString().length < 2) active = '0' + active;
				if(slideLength.toString().length < 2) slideLength = '0' + slideLength;
				navIndex.text(active);
				navLength.text(slideLength);

				var lineWidth = 100/slides.length;
				gsap.set(navLine, {width:`${lineWidth}%`})
			}

			if(self.hasClass("is-draggable")) {
				const proxy = $('<div></div>');
				Draggable.create(proxy, {
					trigger: self,
					type: "x",
					cursor: "grab",
					activeCursor: "grabbing",
					onDrag: function() {
						if(this.deltaX > 10) {
							prevClick();
						}
						if(this.deltaX < -10) {
							nextClick();
						}
					}
				});
			}

			function looper() {
				var autoplayTimer = self.data("autoplay");
				nextLoop = gsap.delayedCall(autoplayTimer, function() {
					nextClick();
				});
			}

			if (self.hasClass("has-autoplay")) {
				looper();
			}

			function navHover() {
				const nextArrow = nextNav.find('.thefutur-icons'),
					prevArrow = prevNav.find('.thefutur-icons'),
				    tlPrev = gsap.timeline({paused:true}),
				    tlNext = gsap.timeline({paused:true});

				tlNext.to(nextArrow, {duration:0.15,xPercent:100,ease: "sine.in"})
				.fromTo(nextArrow, {xPercent:-100}, {duration:0.15,xPercent:0,immediateRender:false,ease:"sine.out"});

				tlPrev.to(prevArrow, {duration:0.15,xPercent:-100,ease: "sine.in"})
				.fromTo(prevArrow, {xPercent:100}, {duration:0.15,xPercent:0,immediateRender:false,ease:"sine.out"});

				nextNav.on("mouseenter", () => {
					tlNext.play();
				}).on("mouseleave", () => {
					tlNext.reverse();
				})

				prevNav.on("mouseenter", () => {
					tlPrev.play();
				}).on("mouseleave", () => {
					tlPrev.reverse();
				})
			}

			function init() {
				for( var i = 0; i < slides.length; i++ ) {
					var dot = $('<div></div>').addClass("wp-block-thefuturblocks-double-slider__bullet").appendTo(dots);
					var dotInner = $('<div></div>').addClass("wp-block-thefuturblocks-double-slider__bullet-inner").appendTo(dot);
		        }
				self.find(".wp-block-thefuturblocks-double-slider__bullet:first-child").addClass("active");
				var dotClicked = self.find(".wp-block-thefuturblocks-double-slider__bullet");
				var dotClickedInner = dotClicked.find(".wp-block-thefuturblocks-double-slider__bullet-inner");
				dotClicked.on('click', dotClick);

				nextNav.on('click', nextClick);
				prevNav.on('click', prevClick);
				navHover();

				var activeDot = self.find(".wp-block-thefuturblocks-double-slider__bullet.active"),
		          activeDotInner = activeDot.find(".wp-block-thefuturblocks-double-slider__bullet-inner"),
		          defDot = self.find(".wp-block-thefuturblocks-double-slider__bullet"),
		          defDotInner = defDot.find(".wp-block-thefuturblocks-double-slider__bullet-inner");

		        gsap.set(defDotInner, {backgroundColor:dotColor, borderColor:dotBorderColor});
		        gsap.set(activeDotInner, {backgroundColor:activeDotColor, borderColor:dotActiveBorderColor});

				const activeSlide = self.find(".wp-block-thefuturblocks-double-slide:first");
				gsap.set(activeSlide, {autoAlpha: 1, className: "wp-block-thefuturblocks-double-slide active"});
		        slideIndex();
			}
			init();
	    })
	}
}

function heroImageFunction() {
  if($(".wp-block-thefuturblocks-double-slide").length) {
    $(".wp-block-thefuturblocks-double-slide").each(function() {
      const self = $(this),
        image = self.find(".wp-block-thefuturblocks-double-slide__image img"),
        image2 = self.find(".wp-block-thefuturblocks-double-slide__inner-image img"),
        tl = gsap.to(image, {duration: 1, yPercent:-16.6, ease:"none"});
      const st = ScrollTrigger.create({
        trigger: self,
        start: 'top +=200',
        end: 'bottom +=200',
        scrub: 0.5,
          toggleActions: "play reverse play reverse",
        animation: tl,
      });
        
    });
  }
}

$(window).on('load', () => {
  heroSliderFunction();
  heroImageFunction();
});
